import React from 'react';
import AssignedDocuments from './AssignedDocuments';

/**
 * EL-only page: lists wills assigned to this Estate Lawyer by their
 * actively-associated Estate Owners. One row per submission (no version expansion).
 */
const EstateLawyerAssignedDocuments: React.FC = () => (
  <AssignedDocuments
    endpoint="/documents/estate-lawyer/assigned-documents"
    title="Documents From My Clients"
    subtitle="Documents assigned to you by your associated Estate Owners."
    emailColumnLabel="Owner"
    showOwnerEmail={true}
  />
);

export default EstateLawyerAssignedDocuments;
